import { jsx, jsxs } from "react/jsx-runtime";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
const styles_css_ts_vanilla = "";
var tooltipContent = "la997z0";
const Tooltip = ({
  children,
  content,
  side = "top",
  align = "center",
  options,
  rootOptions,
  portalOptions
}) => {
  if (!content) {
    return children;
  }
  return /* @__PURE__ */ jsx(TooltipPrimitive.Provider, { children: /* @__PURE__ */ jsxs(TooltipPrimitive.Root, { delayDuration: 500, ...rootOptions, children: [
    /* @__PURE__ */ jsx(TooltipPrimitive.Trigger, { asChild: true, children }),
    /* @__PURE__ */ jsx(TooltipPrimitive.Portal, { ...portalOptions, children: /* @__PURE__ */ jsxs(
      TooltipPrimitive.Content,
      {
        className: tooltipContent,
        side,
        align,
        sideOffset: 5,
        style: { zIndex: "var(--affine-z-index-popover)" },
        ...options,
        children: [
          content,
          /* @__PURE__ */ jsx(
            TooltipPrimitive.Arrow,
            {
              height: 6,
              width: 10,
              fill: "var(--affine-tooltip)"
            }
          )
        ]
      }
    ) })
  ] }) });
};
export {
  Tooltip as T
};
